<template lang="pug">
  .me-avatar
    .wrapper
      img(:src="user.avatar")
    .copy
      .nickname {{user.nickname}}
      .member
        member(:grade="user.grade")

</template>

<script>
import gsap from 'gsap'
import Member from '@/components/wedgits/Member'
import { mapState } from 'vuex'
export default {
  name: 'MeAvatar',
  components: { Member },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    animeIn(offsets) {
      gsap.fromTo(
        this.$el,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        }
      )
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.me-avatar
  //width: pxToRem(96)
  //height: pxToRem(84)
  //background: aquamarine
  //opacity: 0
  display: flex
  flex-direction: row
  align-items: center
  .wrapper
    line-height: 0
    width: pxToRem(96)
    height: pxToRem(96)
    border-radius: pxToRem(48)
    overflow: hidden
    img
      width: 100%
      object-fit: contain
  .copy
    margin-left: pxToRem(40)
    margin-top: pxToRem(-15)
    .nickname
      font-size: pxToRem(36)
      color: black
      letter-spacing: pxToRem(0.8)
    .member
      margin-left: pxToRem(-5)
      line-height: 0
      width: pxToRem(146)
      height: pxToRem(32)
</style>
